import React, {useEffect, useState} from 'react';
import {useAppDispatch} from "../app/hooks";
import {Progress} from "antd";
import {setMode} from "../features/omikuji/omikujiSlice";

export function Screen5_Pray_wait10sec(props: any) {
    const dispatch = useAppDispatch();
    let currentPercent = 10
    let isMoving = false
    const [percent, setPercent] = useState(currentPercent)
    useEffect(() => {
        if (isMoving) return
        isMoving = true
        setInterval(() => {
            const current = currentPercent
            const next = current + 10
            currentPercent = next
            setPercent(currentPercent)
        }, 1000)
    }, [])
    useEffect(() => {
        if (percent > 100) {
            dispatch(setMode("mode6_Ready"))
        }
    }, [percent])

    return <>
        <p>2023年の願い事を10秒間思い浮かべてね</p>
        <Progress type="circle" percent={percent} format={(percent) => {
            return percent ? percent / 10 : 0
        }
        }/>
    </>
}
